document.addEventListener('click', function (event) {
  var button = event.target.closest('.special-offers__card-button');
  if (!button) return;
  var code = button.dataset.code;
  if (!code) return;

  var write = navigator.clipboard && window.isSecureContext
    ? navigator.clipboard.writeText(code)
    : Promise.resolve().then(function () {
        var textarea = document.createElement('textarea');
        textarea.value = code;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      });

  write.then(function () {
    var label = button.querySelector('.special-offers__card-button-text');
    var original = label.textContent;
    button.classList.add('is-copied');
    label.textContent = 'Copied!';
    setTimeout(function () {
      button.classList.remove('is-copied');
      label.textContent = original;
    }, 2000);
  });
});
